<template>
  <div class="withdrawal-detail">
    <ul class="info-list">
      <li>
        <span>推荐人</span>
        <span>{{ data.recommenderName }}</span>
      </li>
      <li>
        <span>推荐人手机号码</span>
        <span>{{ data.recommenderPhone }}</span>
      </li>
      <li>
        <span>申请提现金额</span>
        <span>{{ data.rewardAmount }} 元</span>
      </li>
      <li>
        <span>被推荐人</span>
        <span>
          {{ data.userNames }}
        </span>
      </li>
    </ul>

    <template v-if="queryParams.uid">
      <h3>被推荐人入离职记录</h3>

      <el-tabs v-model="queryParams.uid" @tab-click="query(1)">
        <el-tab-pane v-for="(item, index) in data.userVos" :key="index" :label="item.name" :name="item.uid" />
      </el-tabs>

      <!-- 表格 -->
      <el-table v-loading="loading" border :data="tableData" :table-layout="'auto'">
        <el-table-column label="公司" prop="enterpriseName" show-overflow-tooltip />
        <el-table-column label="项目编码" prop="outJobCode" />
        <el-table-column label="岗位" prop="jobName" />
        <el-table-column label="入离职时间" :width="248">
          <template #default="{ row }">
            {{ row.departureTime ? `离职时间：${row.departureTime}` : `入职时间：${row.entryTime}` }}
          </template>
        </el-table-column>
        <template #empty>
          <el-empty class="vab-data-empty" description="暂无数据" />
        </template>
      </el-table>

      <!-- 分页 -->
      <el-pagination
        v-model:current-page="queryParams.pageNum"
        background
        layout="prev, pager, next"
        :page-size="queryParams.pageSize"
        :total="queryParams.total"
        @current-change="query"
      />
    </template>
  </div>
</template>

<script setup>
  import { ref, reactive, defineProps, onMounted } from 'vue'
  import { getWithdrawalDetail } from '@/api/recruitment'
  import { get, omit } from 'lodash'

  const props = defineProps({
    data: {
      type: Object,
      required: true,
    },
  })

  const defaultQueryParams = {
    uid: get(props.data, 'userVos.0.uid') || '',
    groupCode: props.data.groupCode,
    pageNum: 1,
    pageSize: 20,
    total: 0,
  }

  const queryParams = reactive({ ...defaultQueryParams })

  const loading = ref(false)
  const tableData = ref([])

  onMounted(() => {
    query(1)
  })

  let lastParams = ''
  function query(pageNum = queryParams.pageNum) {
    const params = {
      ...omit(queryParams, 'total'),
      pageNum,
    }

    const stringifyParams = JSON.stringify(params)
    if (stringifyParams === lastParams) return

    loading.value = true

    getWithdrawalDetail(params)
      .then(({ code, data }) => {
        if (code !== 200) return
        const { list, total } = data
        tableData.value = list
        queryParams.total = total
      })
      .finally(() => {
        loading.value = false
        lastParams = stringifyParams
      })
  }
</script>

<style lang="scss" scoped>
  .info-list {
    line-height: 1.5;
    margin-bottom: 50px;

    span:first-child {
      display: inline-block;
      width: 100px;
      font-weight: 500;
    }
  }
</style>
